import React, { useState, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import './BuildMatrixModal.scss';
import { update as updateMatrix } from 'actions/matrixSettings';
import { createNode, pseudoTrophicLayerName } from 'constants/nodes';
import TextField from 'components/inputs/TextField';
import ButtonNew from 'components/inputs/ButtonNew';
import text from 'constants/text';
import BuildMatrixFooterButtons from './BuildMatrixFooterButtons';
import BuildMatrixImportConnections from './BuildMatrixImportConnections';
import Button from 'components/inputs/Button';

const BuildMatrixAddNodes = ({ matrix, toNext, toPrev }) => {
  const dispatch = useDispatch();

  const nodes = useMemo(() => {
    let matrixNodes = matrix?.nodes ?? {};
    return Object.values(matrixNodes);
  }, [matrix]);

  const [textField, setTextField] = useState('');

  const submitNode = () => {
    const matrixId = matrix?.id;
    if (!matrixId || !textField) return;
    const node = createNode();
    node.trophicLevel = pseudoTrophicLayerName;
    node.name = textField;
    const nextMatrix = {
      ...matrix,
      nodes: {
        ...matrix.nodes,
        [node.id]: node,
      },
    };
    dispatch(updateMatrix(nextMatrix));
    setTextField('');
  };

  const removeNode = node => {
    const matrixId = matrix?.id;
    if (!matrixId) return;
    const nextNodes = matrix?.nodes ?? {};
    delete nextNodes[node.id];
    const nextMatrix = {
      ...matrix,
      nodes: nextNodes,
    };
    dispatch(updateMatrix(nextMatrix));
  };

  return (
    <div className="BuildMatrixAddNodes">
      <div className="BuildMatrixIntro-header">
        <Button
          className="BuildMatrixIntro-arrows"
          icon="leftArrow"
          onClick={toPrev}
        />
        <div className="BuildMatrixIntro-instruction">
          Begin by making a list of nodes to include in your matrix
        </div>
        <Button
          className="BuildMatrixIntro-arrows disabled"
          icon="rightArrow"
          onClick={() => false}
        />
      </div>
      <div className="BuildMatrixAddNodes-container">
        <div className="BuildMatrixAddNodes-row no-shrink">
          <div className="content">
            <div className="header text-interface-large">Nodes</div>
            <div className="description text-interface-medium">
              {text.buildAMatrixGuide.addNodes}
            </div>
            <div className="text-container">
              <TextField
                className="text-input"
                onChange={setTextField}
                value={textField}
              />

              <ButtonNew
                buttonClasses="icon-button"
                icon="rightArrow"
                onClick={submitNode}
              />
            </div>
            {/* <div className="BuildMatrixAddNodes-import-container">
              <BuildMatrixImportConnections matrix={matrix} />
            </div> */}
          </div>
        </div>
        <div className="BuildMatrixAddNodes-row grow">
          <div className="node-container">
            {nodes.map(node => (
              <div className="node" key={node.id}>
                <div className="node-name">{node.name}</div>
                <ButtonNew
                  icon="trash"
                  onClick={() => removeNode(node)}
                  buttonClasses="icon-button-small"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <BuildMatrixFooterButtons
        skip={toNext}
        goNext={toNext}
        nextText={`Let's get started!`}
      />
    </div>
  );
};

export default BuildMatrixAddNodes;
